(function () {
  function tidyDescriptions(root) {
    root.querySelectorAll('[data-bp-description]').forEach(function (body) {
      if (body.dataset.ready) return;
      body.dataset.ready = 'true';
      body.querySelectorAll('p, div').forEach(function (element) {
        if (!element.textContent.trim() && !element.querySelector('img,iframe,video,table,input')) element.remove();
      });
      body.querySelectorAll('strong').forEach(function (label) {
        if (label.textContent.trim() !== 'Tags:') return;
        var next = label.nextSibling;
        while (next && (next.nodeType === 3 || next.nodeName === 'EM' || next.nodeName === 'BR')) {
          var following = next.nextSibling; next.remove(); next = following;
        }
        label.remove();
      });
      body.querySelectorAll('p').forEach(function (paragraph) {
        var lines = paragraph.innerHTML.split(/<br\s*\/?\s*>/i);
        var nonempty = lines.filter(function (line) { return line.replace(/<[^>]*>/g, '').trim(); });
        if (nonempty.length < 2 || !nonempty.every(function (line) { return /^[\s\u00a0]*(?:—|–|•|\.:|✓|✔)/.test(line.replace(/<[^>]*>/g, '')); })) return;
        var list = document.createElement('ul');
        nonempty.forEach(function (line) { var item = document.createElement('li'); item.innerHTML = line.replace(/^(\s*(?:<[^>]*>)*)[\s\u00a0]*(?:—|–|•|\.:|✓|✔)\s*/, '$1'); list.appendChild(item); });
        paragraph.replaceWith(list);
      });
      var section = body.closest('.bp-product-information');
      var target = section && section.querySelector('[data-bp-tables]');
      if (target) body.querySelectorAll('table').forEach(function (table) {
        var wrapper = document.createElement('div'); wrapper.className = 'bp-table-scroll'; wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region'); wrapper.setAttribute('aria-label', section.querySelector('.bp-specifications h3').textContent);
        target.appendChild(wrapper); wrapper.appendChild(table); section.querySelector('[data-bp-specifications]').hidden = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tidyDescriptions(document); }); else tidyDescriptions(document);
  document.addEventListener('shopify:section:load', function (event) { tidyDescriptions(event.target); });
})();
